"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions = exports.initialState = exports.types = void 0;
/* eslint-disable default-param-last */
const deepmerge_1 = __importDefault(require("deepmerge"));
const next12_utils_custo_1 = require("@gcloud-npm/next12.utils.custo");
const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";
exports.types = {
    GET_CREATIVITY: "CUSTO/GET_CREATIVITY",
    SET_CREATIVITY: "CUSTO/SET_CREATIVITY",
    UPDATE_CREATIVITY: "CUSTO/UPDATE_CREATIVITY",
    SET_DRAFT_CHANGE: "CUSTO/SET_DRAFT_CHANGE",
    SET_EDIT_MODE: "CUSTO/SET_EDIT_MODE",
    APPLY_SESSION_DRAFT: "CUSTO/APPLY_SESSION_DRAFT",
    APPLY_SESSION_DRAFT_CLIENT: "CUSTO/APPLY_SESSION_DRAFT_CLIENT",
    LIST_CHANGES: "CUSTO/LIST_CHANGES",
    RESET_CREATIVITY_OVERRIDE: "CUSTO/RESET_CREATIVITY_OVERRIDE",
    SET_CREATIVITY_OVERRIDE: "CUSTO/SET_CREATIVITY_OVERRIDE",
    DELETE_NODE: "CUSTO/DELETE_NODE",
    ADD_NODE: "CUSTO/ADD_NODE",
    RESORT_NODE: "RESORT_NODE",
    SET_CUSTO_PARAMS: "CUSTO/SET_CUSTO_PARAMS",
};
exports.initialState = {
    // info
    creativities: {}, // real info from custo
    creativitiesOverride: {}, // merged
    differences: null,
    // flags
    custoParams: null,
    editMode: false,
    allowEdit: `${process.env.NEXT_PUBLIC_ALLOW_EDIT}` === "true",
};
const CustoReducer = (state = exports.initialState, action) => {
    switch (action.type) {
        case HYDRATE: {
            const { custo } = action.payload;
            const nextState = (0, deepmerge_1.default)(state, custo);
            return nextState;
        }
        case exports.types.SET_CUSTO_PARAMS: {
            const { data } = action;
            return Object.assign(Object.assign({}, state), { custoParams: data });
        }
        case exports.types.RESET_CREATIVITY_OVERRIDE: {
            const { creativityId } = action;
            if (creativityId === "all") {
                const creativities = (0, next12_utils_custo_1.getFromSession)(next12_utils_custo_1.CREATIVITY_LIST);
                creativities.forEach((creativityId) => {
                    (0, next12_utils_custo_1.deleteFromSession)(creativityId);
                });
                return Object.assign(Object.assign({}, state), { creativitiesOverride: Object.assign({}, state.creativities) });
            }
            const newCreativitiesOverride = Object.assign(Object.assign({}, state.creativitiesOverride), { [creativityId]: Object.assign({}, state.creativities[creativityId]) });
            (0, next12_utils_custo_1.deleteFromSession)(creativityId);
            return Object.assign(Object.assign({}, state), { creativitiesOverride: newCreativitiesOverride });
        }
        case exports.types.SET_CREATIVITY_OVERRIDE: {
            const { creativityId, info } = action.data;
            (0, next12_utils_custo_1.saveToSession)(creativityId, info);
            return Object.assign(Object.assign({}, state), { creativitiesOverride: Object.assign(Object.assign({}, state.creativitiesOverride), { [creativityId]: info }) });
        }
        case exports.types.LIST_CHANGES: {
            const creativities = (0, next12_utils_custo_1.getCreativitiesList)();
            const diffResults = {};
            creativities.forEach((creativityId) => {
                const originalInfo = state.creativities[creativityId] || {};
                const overrideInfo = state.creativitiesOverride[creativityId] || {};
                diffResults[creativityId] = (0, next12_utils_custo_1.compareObjects)(originalInfo, overrideInfo);
            });
            return Object.assign(Object.assign({}, state), { differences: diffResults });
        }
        case exports.types.SET_DRAFT_CHANGE: {
            const { value, creativityId, name, entryPoint } = action.data;
            const smallObj = {
                [name]: value,
            };
            const change = (0, next12_utils_custo_1.makeUpObj)(entryPoint, smallObj);
            // mergeamos con la creatividad
            const lastCreativityDraft = Object.assign({}, state.creativitiesOverride[creativityId]);
            let currentCreativity = (0, deepmerge_1.default)(lastCreativityDraft, change);
            // mergeamos con todo
            const newCreativitiesOverride = Object.assign(Object.assign({}, state.creativitiesOverride), { [creativityId]: Object.assign({}, currentCreativity) });
            // guardamos en session
            (0, next12_utils_custo_1.saveToSession)(creativityId, currentCreativity);
            return Object.assign(Object.assign({}, state), { creativitiesOverride: newCreativitiesOverride });
        }
        case exports.types.SET_CREATIVITY: {
            // storing creativity data from custo
            const { data } = action;
            const { creativityId, info } = data;
            return Object.assign(Object.assign({}, state), { creativities: Object.assign(Object.assign({}, state.creativities), { [creativityId]: info }) });
        }
        case exports.types.APPLY_SESSION_DRAFT_CLIENT: {
            let creativitiesOverride = Object.assign({}, state.creativitiesOverride);
            const creativities = (0, next12_utils_custo_1.getCreativityDraftInfo)(action.creativityId);
            creativities.forEach((creativityName) => {
                let creativityInfo = (0, next12_utils_custo_1.getFromSession)(creativityName);
                if (!creativityInfo) {
                    creativityInfo = state.creativities[creativityName];
                }
                creativitiesOverride = Object.assign(Object.assign({}, creativitiesOverride), { [creativityName]: creativityInfo });
            });
            return Object.assign(Object.assign({}, state), { creativitiesOverride });
        }
        case exports.types.SET_EDIT_MODE:
            return Object.assign(Object.assign({}, state), { editMode: action.flag });
        case exports.types.DELETE_NODE: {
            const { creativityId, entryPoint } = action.data;
            const currentDraft = Object.assign({}, state.creativitiesOverride[creativityId]);
            const newDraft = (0, next12_utils_custo_1.deleteByDotNotation)(currentDraft, entryPoint);
            const newOverrides = Object.assign(Object.assign({}, state.creativitiesOverride), { [creativityId]: Object.assign({}, newDraft) });
            // guardamos en session
            (0, next12_utils_custo_1.saveToSession)(creativityId, newDraft);
            return Object.assign(Object.assign({}, state), { creativitiesOverride: Object.assign({}, newOverrides) });
        }
        case exports.types.RESORT_NODE: {
            const { creativitiesOverride } = state;
            const { listSorted, entryPoint, creativityId } = action.data;
            let newCreativitiesOverride = Object.assign({}, creativitiesOverride);
            if (creativitiesOverride && creativitiesOverride[creativityId]) {
                const finalListSorted = listSorted.map((item) => item.name);
                let infoData = (0, next12_utils_custo_1.getByDotNotation)(creativitiesOverride[creativityId], entryPoint);
                console.log("entrypoint", { entryPoint });
                console.log("antes:", { infoData });
                const change = (0, next12_utils_custo_1.makeUpObj)(entryPoint, (0, next12_utils_custo_1.sortObjectByKeys)(infoData, finalListSorted));
                newCreativitiesOverride = Object.assign(Object.assign({}, newCreativitiesOverride), { [creativityId]: Object.assign(Object.assign({}, newCreativitiesOverride[creativityId]), change) });
                console.log("después:", {
                    change,
                    newCreativitiesOverride,
                });
            }
            return Object.assign(Object.assign({}, state), { creativitiesOverride: newCreativitiesOverride });
        }
        default:
            return Object.assign({}, state);
    }
};
exports.actions = {
    /* operations */
    setCustoParams: (data) => ({
        type: exports.types.SET_CUSTO_PARAMS,
        data,
    }),
    getCreativity: (data) => ({
        type: exports.types.GET_CREATIVITY,
        data,
    }),
    setCreativity: (data) => ({
        type: exports.types.SET_CREATIVITY,
        data,
    }),
    setDraftChange: (data) => ({
        type: exports.types.SET_DRAFT_CHANGE,
        data,
    }),
    applySessionDraft: (data) => ({
        type: exports.types.APPLY_SESSION_DRAFT,
        data,
    }),
    applySessionDraftClient: (creativityId) => ({
        type: exports.types.APPLY_SESSION_DRAFT_CLIENT,
        creativityId,
    }),
    setEditMode: (flag) => ({
        type: exports.types.SET_EDIT_MODE,
        flag,
    }),
    listChanges: () => ({
        type: exports.types.LIST_CHANGES,
    }),
    resetCreativity: (creativityId) => ({
        type: exports.types.RESET_CREATIVITY_OVERRIDE,
        creativityId,
    }),
    updateCreativity: (data) => ({
        type: exports.types.UPDATE_CREATIVITY,
        data,
    }),
    deleteNode: (data) => ({
        type: exports.types.DELETE_NODE,
        data,
    }),
    addNode: (data) => ({
        type: exports.types.ADD_NODE,
        data,
    }),
    resortNode: (data) => ({
        type: exports.types.RESORT_NODE,
        data,
    }),
    setCreativityOverride: (data) => ({
        type: exports.types.SET_CREATIVITY_OVERRIDE,
        data,
    }),
};
exports.default = CustoReducer;
//# sourceMappingURL=index.js.map